export default __webpack_public_path__ + "static/media/480_dummy2016-beauty01-mobile-de.5e6dff51.png";